/* eslint-disable array-bracket-newline */
import { FetchBalanceArgs, fetchBalance } from 'wagmi/actions';

export const fetchEVMBalance = async (args: FetchBalanceArgs) => {
  return await fetchBalance(args);
};
